import React from 'react'
import vbBg from "../../assets/vb-bg.png"
import vbNameTag from "../../assets/TAg.png"
import { CloseCircleOutlined } from '@ant-design/icons'

function ValueBuddiesContentModal({ isCustomModalOpen, setCustomModalOpen, selectedBuddy, valueBuddyDesc }) {
    let checkId = selectedBuddy?.id - 1;

    const renderContent = () => {
        if (valueBuddyDesc?.length > 0) {
            const sentences = valueBuddyDesc[checkId].split('. ');

            if (sentences.length > 1) {
                return (
                    <ul style={{ padding: 0 }}>
                        {sentences.map((sentence, index) => (
                            <li key={index}>{sentence.trim()}</li>
                        ))}
                    </ul>
                );
            } else {
                return <div>{valueBuddyDesc[checkId]}</div>;
            }
        }
        return null;
    };

    return (
        <div className='r-c-c-c' style={{ position: "relative", zIndex: 101 }}>
            <div style={{ position: "absolute", height: "75%", width: "84%", display: "flex", alignItems: "flex-start", justifyContent: "flex-end", cursor: "pointer" }} onClick={() => setCustomModalOpen(false)} >
                <CloseCircleOutlined style={{ fontSize: "25px" }} />
            </div>
            <div>
                <img className='full-img' src={vbBg} alt="Background" />
            </div>
            <div className='display-flex' style={{ position: "absolute", width: "80%", top: "18%", alignItems: "center" }}>
                <div className='vb-img' >
                    <img className="full-img cursor-pointer" src={selectedBuddy?.image} alt="Buddy Image" />
                    <div className='r-c-c' style={{ position: "relative" }} >
                        <img className="full-img cursor-pointer" src={vbNameTag} alt="Name Tag" />
                        <div className='r-c-c vb-name'>{selectedBuddy?.name}</div>
                    </div>
                </div>
                <div className='vb-content m-l-30' style={{}}>
                    {renderContent()}
                </div>
            </div>
        </div>
    );
}

export default ValueBuddiesContentModal
